import { useCallback } from "react";
import { Button, Drawer, Form, Input } from "antd";
import type { MarketingCabinetCreateType } from "@src/types";
import { useMarketingCabinetRegister } from "@src/queries";

type Props = {
    open: boolean;
    onClose: () => void;
};

export default function MarketingCabinetRegisterDrawer({ open, onClose }: Props) {
    const [form] = Form.useForm<MarketingCabinetCreateType>();
    const { mutateAsync, isPending } = useMarketingCabinetRegister();

    const handleFinish = useCallback(
        async (values: MarketingCabinetCreateType) => {
            await mutateAsync(values, {
                onSuccess: () => {
                    form.resetFields();
                    onClose();
                },
            });
        },
        [form, mutateAsync, onClose],
    );

    const handleClose = useCallback(() => {
        if (isPending) return;
        form.resetFields();
        onClose();
    }, [form, isPending, onClose]);

    return (
        <Drawer
            title="Добавить маркетинг"
            open={open}
            onClose={handleClose}
            destroyOnHidden
            maskClosable={!isPending}
            extra={
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={isPending}
                    onClick={() => form.submit()}
                >
                    Сохранить
                </Button>
            }
        >
            <Form<MarketingCabinetCreateType>
                layout="vertical"
                form={form}
                onFinish={handleFinish}
                requiredMark="optional"
            >
                <Form.Item
                    label="Логин"
                    name="username"
                    rules={[{ required: true, message: "Введите логин кабинета" }]}
                >
                    <Input placeholder="Логин кабинета" autoFocus />
                </Form.Item>

                <Form.Item
                    label="Пароль"
                    name="password"
                    rules={[{ required: true, message: "Введите пароль от кабинета" }]}
                >
                    <Input.Password placeholder="Пароль от кабинета" />
                </Form.Item>
            </Form>
        </Drawer>
    );
}
